var labelType, useGradients, nativeTextSupport, animate;

(function() {
  var ua = navigator.userAgent,
      iStuff = ua.match(/iPhone/i) || ua.match(/iPad/i),
      typeOfCanvas = typeof HTMLCanvasElement,
      nativeCanvasSupport = (typeOfCanvas == 'object' || typeOfCanvas == 'function'),
      textSupport = nativeCanvasSupport 
        && (typeof document.createElement('canvas').getContext('2d').fillText == 'function');
  labelType = (!nativeCanvasSupport || (textSupport && !iStuff))? 'Native' : 'HTML';
  nativeTextSupport = labelType == 'Native';
  useGradients = nativeCanvasSupport;
  animate = !(iStuff || !nativeCanvasSupport);
})();

var Log = {
  elem: false,
  write: function(text){
    if (!this.elem)
      this.elem = document.getElementById('log');
    this.elem.innerHTML = text;
    this.elem.style.left = (500 - this.elem.offsetWidth / 2) + 'px';
  }
};

var icicle;

function loadCreditStructure(json){
  controls();
  icicle = new $jit.Icicle({
    injectInto: 'infovis',
    animate: animate,
    offset: 5,
    cushion: false,
    constrained: true,
    levelsToShow: 2,
    Tips: {
      enable: true,
      type: 'Native',
      offsetX: 20,
      offsetY: 20,
      onShow: function(tip, node){
        var count = 0;
        node.eachSubnode(function(){ count++; });
        tip.innerHTML = `
          <div class="text-xs text-center mb-0.5 p-2 border border-neutral-200 bg-neutral-100">
            <b>Name:</b> ${node.name}
            <div>${count} Securities</div>
          </div>
        `;
      }
    },
    Events: {
      enable: true,
      onMouseEnter: function(node) {
        node.setData('border', '#33dddd');
        icicle.fx.plotNode(node, icicle.canvas);
        icicle.labels.plotLabel(icicle.canvas, node, icicle.controller);
      },
      onMouseLeave: function(node) {
        node.removeData('border');
        icicle.fx.plot();
      },
      onClick: function(node){
        if (node) {
          icicle.tips.hide();
          if(icicle.events.hovered)
            this.onMouseLeave(icicle.events.hovered);
          icicle.enter(node);
        }
      },
      onRightClick: function(){
        icicle.tips.hide();
        if(icicle.events.hovered)
          this.onMouseLeave(icicle.events.hovered);
        icicle.out();
      }
    },
    Label: {
      type: labelType
    },
    onCreateLabel: function(domElement, node){
      domElement.innerHTML = node.name;
      var style = domElement.style;
      style.fontSize = '0.9em';
      style.display = '';
      style.cursor = 'pointer';
      style.color = '#333';
      style.overflow = 'hidden';
    },
    onPlaceLabel: function(domElement, node){
      var style = domElement.style,
          width = node.getData('width'),
          height = node.getData('height');
      if(width < 7 || height < 7) {
        style.display = 'none';
      } else {
        style.display = '';
        style.width = width + 'px';
        style.height = height + 'px';
      }
    }
  });
  icicle.loadJSON(json);
  icicle.refresh();
}

function controls() {
  var jit = $jit;
  var gotoparent = jit.id('update');
  jit.util.addEvent(gotoparent, 'click', function() {
    icicle.out();
  });
}

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initializedCharts = new Set();

  connect() {
    this.element.addEventListener('click', this.onTabClick.bind(this));
    const activeTab = this.element.querySelector('button[aria-selected="true"]') || this.element.querySelector('button[data-tab-id]');
    if (activeTab) this.activateTab(activeTab.dataset.tabId);

    // Initialize selected count
    this.updateSelectedCount();

    // Listen for selection changes
    document.addEventListener('securities-selection-changed', () => {
      this.updateSelectedCount();
    });
  }

  onTabClick(event) {
    const tabButton = event.target.closest('button[data-tab-id]');
    if (tabButton && this.element.contains(tabButton)) {
      this.activateTab(tabButton.dataset.tabId);
    }
  }

  activateTab(tabId) {
    this.element.querySelectorAll('button[data-tab-id]').forEach(tab => {
      const isActive = tab.dataset.tabId === tabId;
      tab.classList.toggle('border-primary', isActive);
      tab.classList.toggle('text-primary', isActive);
      tab.classList.toggle('border-transparent', !isActive);
      tab.classList.toggle('text-neutral-500', !isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.element.querySelectorAll('.tab-panel').forEach(panel => {
      const isActive = panel.dataset.tabId === tabId;
      panel.classList.toggle('hidden', !isActive);
      if (isActive) this.initChartForPanel(panel);
    });
  }

  chartInitializers = {
    "tabpanel-price": () => this.initChart({
      elId: "security-price",
      dataKey: "priceChart",
      type: "stock",
      config: this.priceChartConfig
    }),
    "tabpanel-maturity": () => this.initChart({
      elId: "yield-to-maturity",
      dataKey: "maturityChart",
      type: "normal",
      config: this.maturityChartConfig
    }),
    "tabpanel-running": () => this.initChart({
      elId: "security-running",
      dataKey: "runningChart",
      type: "stock",
      config: this.runningChartConfig
    }),
    "tabpanel-margin": () => this.initChart({
      elId: "security-margin",
      dataKey: "marginChart",
      type: "stock",
      config: this.marginChartConfig
    }),
    "tabpanel-performance": () => this.initChart({
      elId: "security-performance",
      dataKey: "performanceChart",
      type: "stock",
      config: this.performanceChartConfig
    })
  };

  initChartForPanel(panel) {
    if (this.initializedCharts.has(panel.id)) return;
    const initializer = this.chartInitializers[panel.id];
    if (initializer) initializer();
    this.initializedCharts.add(panel.id);
  }

  initChart({ elId, dataKey, type, config }) {
    const el = this.element.querySelector(`#${elId}`);
    if (!el || !el.dataset[dataKey]) return;
    const data = JSON.parse(el.dataset[dataKey]);
    const chartConfig = config.call(this, data);
    if (type === "stock") {
      Highcharts.stockChart(el, chartConfig);
    } else {
      Highcharts.chart(el, chartConfig);
    }
  }

  priceChartConfig(data) {
    return {
      rangeSelector: { selected: 1 },
      title: { text: '' },
      credits: { enabled: false },
      tooltip: {
        style: { width: '200px' },
        enabled: true,
        useHTML: true,
        formatter: function () {
          let price = "-";
          let volume = "-";
          this.points.forEach(point => {
            if (point.series.name === "Last Price") price = point.y.toFixed(3);
            else if (point.series.name === "Volume") volume = point.y.toFixed(0);
          });
          let s = Highcharts.dateFormat('%A, %b %e, %Y', this.x);
          s += '<br/><b>Last Price: ' + price + '</b>';
          s += '<br/><b>Volume: ' + volume + '</b>';
          return s;
        }
      },
      xAxis: { minRange: 14 * 24 * 3600000, type: 'datetime' },
      yAxis: [
        { labels: { align: 'right', x: -2 }, title: { text: 'Last Price' }, height: 200, lineWidth: 2 },
        { labels: { align: 'right', x: -2 }, title: { text: 'Volume' }, height: 80, top: 270, offset: 0, lineWidth: 2 }
      ],
      legend: { enabled: false },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, Highcharts.getOptions().colors[0]],
              [1, new Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
            ]
          },
          marker: { radius: 2 },
          lineWidth: 1,
          states: { hover: { lineWidth: 1 } },
          threshold: null
        }
      },
      series: [
        {
          type: 'area',
          name: 'Last Price',
          pointInterval: 24 * 3600 * 1000,
          data: data.data_price,
          yAxis: 0
        },
        {
          type: 'column',
          name: 'Volume',
          data: data.data_volume,
          pointInterval: 24 * 3600 * 1000,
          yAxis: 1
        }
      ]
    };
  }

  maturityChartConfig(data) {
    return {
      title: { text: '' },
      xAxis: { type: 'datetime' },
      yAxis: { title: { text: null } },
      tooltip: { enabled: true, useHTML: true, crosshairs: false, shared: false, valuePrefix: '' },
      legend: {},
      series: [
        {
          name: 'Capital Price',
          data: data.prices,
          zIndex: 1,
          marker: { fillColor: 'transparent', lineWidth: 0, lineColor: Highcharts.getOptions().colors[0] }
        },
        {
          name: 'Accrued',
          data: data.ranges,
          type: 'arearange',
          lineWidth: 0,
          color: new Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0.3).get('rgba'),
          zIndex: 0
        }
      ]
    };
  }

  runningChartConfig(data) {
    return {
      rangeSelector: { inputEnabled: false, selected: 1 },
      title: { text: '' },
      exporting: { enabled: false },
      credits: { enabled: false },
      scrollbar: { enabled: false },
      tooltip: {
        style: { width: '200px' },
        enabled: true,
        useHTML: true,
        formatter: function () {
          let s = Highcharts.dateFormat('%A, %b %e, %Y', this.x);
          s += '<br/><b>Yield : ' + Math.round(this.y * 100 * 1000)/1000 + ' %' + '</b>';
          return s;
        }
      },
      yAxis: {
        title: { text: 'Yield to Maturity' },
        labels: {
          formatter: function () {
            return Math.round(this.value * 100 * 1000)/1000 + ' %';
          }
        }
      },
      series: [{ name: 'Yield', data: data.yield, id: 'dataseries' }]
    };
  }

  marginChartConfig(data) {
    const marginLabel = data.margin_label || 'Trading Margin';
    return {
      rangeSelector: { inputEnabled: false, selected: 1 },
      title: { text: '' },
      exporting: { enabled: false },
      credits: { enabled: false },
      scrollbar: { enabled: false },
      tooltip: {
        enabled: true,
        useHTML: true,
        style: { width: '200px' },
        formatter: function () {
          let s = Highcharts.dateFormat('%A, %b %e, %Y', this.x);
          s += '<br/><b>' + marginLabel + ' : ' + Math.round(this.y * 100 * 1000)/1000 + ' %' + '</b>';
          return s;
        }
      },
      yAxis: {
        title: { text: marginLabel },
        labels: {
          formatter: function () {
            return Math.round(this.value * 100 * 1000)/1000 + ' %';
          }
        }
      },
      series: [{ name: marginLabel, data: data.margins, id: 'dataseries' }]
    };
  }

  performanceChartConfig(data) {
    return {
      rangeSelector: { inputEnabled: false, selected: 1 },
      title: { text: '' },
      exporting: { enabled: false },
      credits: { enabled: false },
      scrollbar: { enabled: false },
      tooltip: {
        enabled: true,
        useHTML: true,
        valueDecimals: 2,
        style: { width: '200px' }
      },
      yAxis: { title: { text: 'Performance' } },
      series: [
        { name: 'Total Return Index', data: data.total_return_indices, id: 'dataseries' },
        { name: 'Net Total Return Index', data: data.net_total_return_indices, id: 'dataseries' },
        { name: 'Non Accumulation Index', data: data.non_accumulation_indices, id: 'dataseries' },
        { name: 'Net Non Accumulation Index', data: data.net_non_accumulation_indices, id: 'dataseries' }
      ]
    };
  }

  addToSelection(event) {
    event.preventDefault();

    const { securityIsin, securityName } = event.currentTarget.dataset;

    if (!securityIsin) {
      console.error('Security ISIN not found');
      return;
    }

    // Get current selected rows from localStorage
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");

    // Check if security is already selected
    if (selectedRows.includes(securityIsin)) {
      alert(`${securityName} is already in your selection.`);
      return;
    }

    // Add security to selection
    selectedRows.push(securityIsin);
    localStorage.setItem("selectedRows", JSON.stringify(selectedRows));

    // Also update selectedRowData to keep in sync with slick grid
    const selectedRowData = JSON.parse(localStorage.getItem("selectedRowData") || "[]");
    const newSelectedData = {
      id: securityIsin,
      name: securityName,
      isin: securityIsin
    };

    // Check if already exists in selectedRowData
    const exists = selectedRowData.some(item => item.id === securityIsin);
    if (!exists) {
      selectedRowData.push(newSelectedData);
      localStorage.setItem("selectedRowData", JSON.stringify(selectedRowData));
    }

    // Dispatch custom event for selection changes
    document.dispatchEvent(new CustomEvent('securities-selection-changed', {
      detail: { selectedRows: selectedRows }
    }));

    // Show success message
    alert(`${securityName} has been added to your selection.`);
  }

  createQuoteWithSelected(event) {
    event.preventDefault();

    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");
    if (selectedRows.length === 0) {
      window.location.href = `/oms/quotes/new`;
    } else {
      const isinsParam = selectedRows.join(',').toUpperCase();
      window.location.href = `/oms/quotes/new?isins=${isinsParam}`;
    }
  }

  updateSelectedCount() {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows") || "[]");

    // Update selection counter
    const selectionCountElement = document.getElementById("selection-count-helper");
    if (selectionCountElement) {
      selectionCountElement.textContent = `(${selectedRows.length})`;
    }

    // Update quote selection counter
    const selectedCountElement = document.getElementById("selected-count-helper");
    if (selectedCountElement) {
      selectedCountElement.textContent = `(${selectedRows.length})`;
    }
  }
}
